// extracted by mini-css-extract-plugin
export var desc = "project-item-module--desc--26d8f";
export var files = "project-item-module--files--e63e4";
export var image = "project-item-module--image--398a7";
export var location = "project-item-module--location--f0dcc";
export var root = "project-item-module--root--1a4e4";
export var text = "project-item-module--text--447ca";
export var title = "project-item-module--title--66515";
export var white = "project-item-module--white--3893f";